import _without from 'lodash/without';

import { ActionTypes } from '../actions/draftsActions';

const initialState = {
  busy: false,
  entities: {
    customizations: {},
    drafts: {},
  },
  allIds: [],
};

export default function draftsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case ActionTypes.REQUEST_DRAFTS: {
      return {
        ...state,
        busy: true,
      };
    }
    case ActionTypes.RECEIVE_DRAFTS: {
      const { drafts } = action.payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          ...drafts.entities,
        },
        allIds: drafts.result,
        busy: false,
      };
    }
    case ActionTypes.RECEIVE_DELETE_PROJECT: {
      const { projectUUID } = action.payload;
      // const filteredRawDrafts = state.rawDrafts.filter(draft => draft.project_uuid !== projectUUID);
      // const { groupedDrafts, drafts } = draftsMapper(filteredRawDrafts);
      const allIds = _without(state.allIds, projectUUID);
      return {
        ...state,
        // rawDrafts: filteredRawDrafts,
        // drafts,
        // groupedDrafts,
        allIds,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/cards/reducers/draftsReducer.js